import type { BrandNoteDTO } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { brandNotesKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

interface UseBrandNotesParams {
  brandId: number;
}

export function useBrandNotes({
  brandId,
}: UseBrandNotesParams): UseQueryResult<BrandNoteDTO[]> {
  return useQuery({
    queryFn: async () =>
      apiClient.url(`/brands/${brandId}/notes`).get().json<BrandNoteDTO[]>(),
    queryKey: brandNotesKeys.byBrandId(brandId),
  });
}
